<template>
  <div class="file-preview-wrap">
    <component v-for="(url, key) in srcList" :key="key" :is="getUrlType(url) + 'Preview'" :src="asUrl(url)"></component>
  </div>
</template>

<script>
import utils from '@/js/utils.js'
import imagePreview from './ImagePreview'
import audioPreview from './AudioPreview'
import videoPreview from './VideoPreview'
import otherPreview from './OtherPreview'
export default {
  name: 'FilePreview',
  props:{
    src: [String, Array],
    type: String
  },
  components: { imagePreview, audioPreview, videoPreview, otherPreview },
  computed: {
    srcList () {
      if (Array.isArray(this.src)) {
        return this.src
      }
      return [this.src]
    }
  },
  methods: {
    asUrl(url) {
      return utils.url(url)
    },
    getUrlType(url) {
      if (/\.(png|jpg|jpeg|bmp|gif|pic|tif)$/i.test(url)) {
        return 'image'
      }
      if (/\.(mp3|wav|ram)$/i.test(url)) {
        return 'audio'
      }
      if (/\.(mp4|avi|mpg|mov|swf)$/i.test(url)) {
        return 'video'
      }
      return this.type || 'other'
    }
  }
}
</script>

<style lang="scss">
.file-preview-wrap * {
  &:focus {
    outline: none;
  }
}
</style>